import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
	Button,
	Column,
	Columns,
	PaginatedTable
} from 'vio-components';
import {
	convertUTCStringToLocalDate,
	sortAlphabetically,
	sortByDateValue
} from 'vio-libs';

import {
	IMapFeatureList,
	IMapFeatureRow
} from '../interfaces';
import { getOrphanedLayerTableRows } from '../lib';

const OrphanedLayersList: React.FC<IMapFeatureList> = ({
	isLoading,
	layers,
	sources
}) => {
	const navigate = useNavigate();
	const [ data, setData ] = useState<Array<IMapFeatureRow>>([]);

	const handleDelete = (id: IMapFeatureRow['id']) => {
		navigate(`/layers/${id}/delete`, { state: data.find((fiber: IMapFeatureRow) => (id === fiber.id)) });
	};

	useEffect(() => {
		// build rows from sources and layers
		if (layers && sources && layers.length > 0) {
			setData(getOrphanedLayerTableRows(sources, layers));
		}
	}, [ sources, layers ]);

	return (
		<PaginatedTable
			data={ data }
			pageSize={ 25 }
			requestingTableData={ isLoading }>
			<Columns>
				<Column
					field='name'
					sortable
					sortLogic={ sortAlphabetically }
					sortDir='asc'>
					Name
				</Column>
				<Column field='createdDate'
					defaultSortedColumn
					renderer={ (value: string) => convertUTCStringToLocalDate(value, true) }
					sortable
					sortLogic={ sortByDateValue }
					sortDir='desc'>
					Created Date
				</Column>

				<Column field='updatedDate'
					renderer={ (value: string) => convertUTCStringToLocalDate(value, true) }
					sortable
					sortLogic={ sortByDateValue }
					sortDir='desc'>
					Updated Date
				</Column>

				<Column
					className='h-100'
					field='id'
					renderer={
						(val: IMapFeatureRow['id']) => (
							<Button
								variant='danger'
								onClick={ () => handleDelete(val) }>
								<FontAwesomeIcon icon={ faTrashCan } />Delete
							</Button>)
					} />
			</Columns>
		</PaginatedTable>
	);
};

export default OrphanedLayersList;
